import { render } from "./HighchartsSizeConfiger.vue?vue&type=template&id=0d196822&scoped=true"
import script from "./HighchartsSizeConfiger.vue?vue&type=script&lang=js"
export * from "./HighchartsSizeConfiger.vue?vue&type=script&lang=js"

import "./HighchartsSizeConfiger.vue?vue&type=style&index=0&id=0d196822&scoped=true&lang=scss"

import exportComponent from "/var/lib/jenkins/workspace/bigdatadisplaysystem_php_master/front/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0d196822"]])

export default __exports__